"use client";

import { cn, formatViews } from "@/lib/utils";
import { STATS_API } from "@/lib/constants";
import { useQuery } from "@tanstack/react-query";
import Skeleton from "react-loading-skeleton";

async function getAllStatsData() {
	const url = new URL(STATS_API);
	url.searchParams.set("query", "allStats");
	const res = await fetch(url);
	if (!res.ok) {
		const { message } = await res.json();
		throw new Error(message);
	}
	const data = await res.json();
	return data;
}

const ProductStats = ({ className }: { className?: string }) => {
	const {
		data = { productsCount: 0, usersCount: 0, viewsCount: 0, communitiesCount: 0 },
		isLoading,
	} = useQuery({
		queryKey: ["allStats"],
		queryFn: getAllStatsData,
		refetchOnWindowFocus: false,
		staleTime: 5 * 60 * 1000,
		cacheTime: 10 * 60 * 1000,
	});

	return (
		<div
			className={cn("mx-auto flex w-fit items-center justify-center gap-8 text-left", className)}
		>
			{/* Products */}
			<div className="space-y-1">
				<h3 className="text-2xl font-bold text-brand-primary sm:text-3xl">
					{isLoading ? <Skeleton /> : `${data?.productsCount}+`}
				</h3>
				<span className="block font-medium text-gray-500">Products</span>
			</div>

			<div className="w-px self-stretch bg-gray-300" />

			{/* Members */}
			<div className="space-y-1">
				<h3 className="text-2xl font-bold text-brand-primary sm:text-3xl">
					{isLoading ? <Skeleton /> : `${data?.usersCount}+`}
				</h3>
				<span className="block font-medium text-gray-500">Members</span>
			</div>

			<div className="w-px self-stretch bg-gray-300" />

			{/* Communities */}
			<div className="space-y-1">
				<h3 className="text-2xl font-bold text-brand-primary sm:text-3xl">
					{isLoading ? <Skeleton /> : `${data?.communitiesCount}+`}
				</h3>
				<span className="block font-medium text-gray-500">Communities</span>
			</div>

			<div className="w-px self-stretch bg-gray-300" />

			{/* Views */}
			<div className="space-y-1">
				<h3 className="text-2xl font-bold text-brand-primary sm:text-3xl">
					{isLoading ? <Skeleton /> : formatViews(data?.viewsCount || 0)}
				</h3>
				<span className="block font-medium text-gray-500">Views</span>
			</div>
		</div>
	);
};

export default ProductStats;
